import React from "react";

import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import { makeStyles } from "tss-react/mui";
import { ButtonBase, Typography } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
  outerButton: {
    minWidth: 0,
    flex: 1,
    gridColumn: "span 1",
    textDecoration: "underline",
    flexDirection: "column",
    margin: 0,
    padding: theme.spacing(3),
    borderRadius: "16px",

    "& input": {
      visibility: "collapse",
    },
  },
}));

export const FileUploadButton = ({
  text,
  onFileUpload,
  hasError = false,
  fileName,
}: FileUploadProps) => {
  const { classes } = useStyles();

  const handleFileUpload = ({ target }) => {
    const file = target.files.length ? target.files[0] : null;
    if (file) {
      onFileUpload(file);
    }
  };

  return (
    <ButtonBase
      className={classes.outerButton}
      component="label"
      sx={{
        border: ({ palette }) =>
          `1px dashed ${
            hasError ? palette.error.main : palette.secondary.main
          }`,
      }}
    >
      <InsertPhotoOutlinedIcon color={hasError ? "error" : "secondary"} />
      <Typography align="center" sx={{ mt: 2 }}>
        {fileName || text}
      </Typography>
      <input type="file" onChange={handleFileUpload} />
    </ButtonBase>
  );
};

export type FileUploadProps = {
  text: string;
  onFileUpload: (file: File) => void;
  fullWidth?: boolean;
  hasError?: boolean;
  fileName?: string;
};
